// Restores the legacy Our Story reviews slider's prev/next arrow behavior
// (components/ui/ReviewsSlider.tsx scroll()). The track itself is a plain
// CSS overflow-x-auto snap-x row, so it already works with touch/trackpad
// scrolling and keyboard focus even if this script fails to load - these
// buttons are a progressive enhancement only, scoped to
// [data-testimonial-track] inside sections/our-story-testimonials.liquid.
(function () {
  document.querySelectorAll('[data-testimonial-track]').forEach(function (track) {
    var section = track.closest('.group') || track.parentElement;
    var prevBtn = section && section.querySelector('[data-testimonial-prev]');
    var nextBtn = section && section.querySelector('[data-testimonial-next]');

    function scroll(direction) {
      var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
      var dirMultiplier = isRtl ? -1 : 1;
      var scrollAmount = track.clientWidth * 0.8;
      track.scrollBy({
        left: direction === 'left' ? -scrollAmount * dirMultiplier : scrollAmount * dirMultiplier,
        behavior: 'smooth'
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scroll('left'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scroll('right'); });
  });
})();
